import { TRANSPARENT } from './../../constants';
import { Rect } from './../../math';
import { Rectangle } from './../../svg';
import { deepExtend } from './../../utils/deep-extend';
const defaultOptions = {
    stroke: {
        color: '#778899',
        width: 1,
        dashType: 'dash'
    },
    fill: {
        color: TRANSPARENT
    }
};
export class Selector {
    constructor(diagram) {
        const selectable = diagram.options.selectable;
        this.options = deepExtend({}, defaultOptions, selectable);
        this.visual = new Rectangle(this.options);
        this.diagram = diagram;
    }
    start(p) {
        this._sp = this._ep = p;
        this.refresh();
        this.diagram._adorn(this, true);
    }
    end() {
        this._sp = this._ep = undefined;
        this.diagram._adorn(this, false);
    }
    bounds(value) {
        if (value) {
            this._bounds = value;
        }
        return this._bounds;
    }
    move(p) {
        this._ep = p;
        this.refresh();
    }
    refresh() {
        if (this._sp) {
            const visualBounds = Rect.fromPoints(this.diagram.modelToLayer(this._sp), this.diagram.modelToLayer(this._ep));
            this.bounds(Rect.fromPoints(this._sp, this._ep));
            this.visual.position(visualBounds.topLeft());
            this.visual.redraw({ height: visualBounds.height + 1, width: visualBounds.width + 1 });
        }
    }
}
